export default __webpack_public_path__ + "static/media/xrp-xrp-logo.7bdbdbf3.svg";